import state from './moduleScenarioListState.js'
import mutations from './moduleScenarioListMutations.js'
import actions from './moduleScenarioListActions.js'
import getters from './moduleScenarioListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

